// extracted by mini-css-extract-plugin
export default {"root":"Header_root__J9y3T","topmenu":"Header_topmenu__WH0Be","topmenu_container":"Header_topmenu_container__oqRkQ","logo":"Header_logo__WDMjt","menu":"Header_menu__LbkRE"};